import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=4a12953a&scoped=true&"
import script from "./Nav.vue?vue&type=script&lang=js&"
export * from "./Nav.vue?vue&type=script&lang=js&"
import style0 from "./Nav.vue?vue&type=style&index=0&id=4a12953a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a12953a",
  null
  
)

export default component.exports